import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=a0df16b6"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports